/**
 * Centralized regex strings for form validation.
 * Use with new RegExp(REGEX_STRING) or RegExp(REGEX_STRING).test(value).
 */

/** Standard email format (e.g. PEC or email fields) */
export const PEC_REGEX = '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$';

/** ATECO code format: XX.XX.XX (e.g. 62.02.25) */
export const ATECO_REGEX = '^\\d{2}\\.\\d{2}\\.\\d{2}$';

/** Italian VAT number: exactly 11 digits */
export const VAT_REGEX = '^\\d{11}$';

/** Codice Fiscale: exactly 16 uppercase alphanumeric */
export const CF_REGEX = '^[A-Z]{6}\\d{2}[A-Z]\\d{2}[A-Z]\\d{3}[A-Z]$';

/** SDI code: 6 to 7 uppercase alphanumeric */
export const SDI_REGEX = '^[A-Z0-9]{7}$';

/** Pre-built RegExp instances for convenience */
export const PEC_REGEX_PATTERN = new RegExp(PEC_REGEX);
export const ATECO_REGEX_PATTERN = new RegExp(ATECO_REGEX);
export const VAT_REGEX_PATTERN = new RegExp(VAT_REGEX);
export const CF_REGEX_PATTERN = new RegExp(CF_REGEX);
export const SDI_REGEX_PATTERN = new RegExp(SDI_REGEX);
